export default __webpack_public_path__ + "static/media/arrow.9d7832e6.png";